// KnobToggle — a three-position rotary knob (the client's own design: a
// black bevelled dial with a flat pointer bar and a white indicator at
// its tip). The pointer turns LEFT for "Theoretical Projections", UP for
// "CUSTOM" (the neutral default, and any hand-made selection) and RIGHT
// for "Actuals". Click a label to jump to it, or click the dial itself to
// CYCLE clockwise: Theoretical Projections → CUSTOM → Actuals → back to
// Theoretical Projections. `value` is 'proj' | 'none' | 'act'.

import { FONT } from './util';

const ANGLE = { proj: -90, none: 0, act: 90 };

export default function KnobToggle({ value, onChange, ui, leftLabel = 'Theoretical Projections', topLabel = 'CUSTOM', rightLabel = 'Actuals', leftTitle, topTitle, rightTitle, size = 66 }) {
  const c = size / 2; const r = c - 3;
  const deg = ANGLE[value] ?? 0;
  // A click on the dial turns it one stop clockwise.
  const NEXT = { proj: 'none', none: 'act', act: 'proj' };
  const onDial = () => onChange(NEXT[value] || 'none');
  const nextName = { proj: topLabel, none: rightLabel, act: leftLabel }[value] || topLabel;
  const label = (side, text, title, extra) => {
    const on = value === side;
    return (
      <button type="button" onClick={() => onChange(side)} title={title || (on ? `${text} — selected` : `Turn the knob to ${text}`)}
        style={{ background: 'none', border: 'none', padding: '2px 4px', cursor: 'pointer', fontFamily: FONT, fontSize: 12, fontWeight: 800, letterSpacing: '0.04em', textTransform: 'uppercase', color: on ? ui.fg : ui.muted, whiteSpace: 'nowrap', lineHeight: 1.2, ...(extra || {}) }}>
        {text}
      </button>
    );
  };
  return (
    <span style={{ display: 'inline-grid', gridTemplateColumns: 'auto auto auto', gridTemplateRows: 'auto auto', alignItems: 'center', columnGap: 4, rowGap: 0 }}>
      <span style={{ gridColumn: 2, gridRow: 1, textAlign: 'center' }}>{label('none', topLabel, topTitle)}</span>
      <span style={{ gridColumn: 1, gridRow: 2, textAlign: 'right' }}>{label('proj', leftLabel, leftTitle, { maxWidth: 120, whiteSpace: 'normal', textAlign: 'right' })}</span>
      <svg width={size} height={size} viewBox={`0 0 ${size} ${size}`} onClick={onDial} role="slider" aria-valuetext={value === 'proj' ? leftLabel : value === 'act' ? rightLabel : topLabel}
        style={{ gridColumn: 2, gridRow: 2, cursor: 'pointer', display: 'block', filter: 'drop-shadow(0 2px 3px rgba(0,0,0,0.45))' }}>
        <title>{`Click to turn to ${nextName}`}</title>
        <defs>
          <radialGradient id="knobFace" cx="40%" cy="35%" r="70%">
            <stop offset="0%" stopColor="#4a4a50" />
            <stop offset="55%" stopColor="#2a2a2e" />
            <stop offset="100%" stopColor="#0c0c0e" />
          </radialGradient>
          <linearGradient id="knobRim" x1="0" y1="0" x2="0" y2="1">
            <stop offset="0%" stopColor="#3b3b40" />
            <stop offset="100%" stopColor="#050506" />
          </linearGradient>
        </defs>
        {/* the dial: rim, face, inner bevel */}
        <circle cx={c} cy={c} r={r} fill="url(#knobRim)" />
        <circle cx={c} cy={c} r={r - 3} fill="url(#knobFace)" stroke="#000" strokeWidth="1" />
        <circle cx={c} cy={c} r={r - 6} fill="none" stroke="#5a5a60" strokeWidth="0.8" opacity="0.6" />
        {/* the pointer bar — a flat slot across the face that overhangs the rim, white indicator at the tip */}
        <g style={{ transform: `rotate(${deg}deg)`, transformOrigin: `${c}px ${c}px`, transition: 'transform .35s cubic-bezier(.4,.1,.2,1)' }}>
          <rect x={c - 8} y={c - r - 5} width={16} height={r + 12} rx={2} fill="#1a1a1d" stroke="#a9a9ae" strokeWidth="1.2" />
          <rect x={c - 5.5} y={c - r - 2} width={5} height={13} rx={1} fill="#ffffff" />
        </g>
      </svg>
      <span style={{ gridColumn: 3, gridRow: 2, textAlign: 'left' }}>{label('act', rightLabel, rightTitle)}</span>
    </span>
  );
}
